/** Shared upload configuration for S3 direct and multipart transfers. */
export const UPLOAD_CONFIG = {
  /** Files at or below this size use a single presigned PUT; larger files use multipart. */
  SINGLE_PUT_MAX_BYTES: 8 * 1024 * 1024,

  MIN_PART_SIZE: 5 * 1024 * 1024,
  MAX_PART_SIZE: 500 * 1024 * 1024,
  MAX_PARTS: 100,

  DESKTOP_PART_CONCURRENCY: 4,
  MOBILE_PART_CONCURRENCY: 2,

  MAX_RETRIES: 3,
  RETRY_BASE_DELAY_MS: 1000,

  /** Minimum per-request timeout (ms). */
  BASE_TIMEOUT_MS: 60_000,
  /** Additional timeout budget per megabyte (ms). */
  TIMEOUT_MS_PER_MB: 3_000,
  MAX_TIMEOUT_MS: 60 * 60 * 1000,

  /** UI progress phase boundaries (0–100). */
  PROGRESS: {
    PREPARING_MAX: 5,
    TRANSFER_MAX: 95,
    FINALIZING_MAX: 99,
    COMPLETE: 100,
  },
};
